
import Vue from 'vue'

const component = Vue.extend({})

Vue.component('AMenu', component)
export default component
